import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component

import styles from './CoachPostings.scss';// to import local scss fle

const positions = {
  QBDT: 'Quarterback - Duel Threat',
  QBPS: 'Quarterback - Pro Style',
  WR: 'Wide Receiver',
  SR: 'Slot Receiver',
  RB: 'Running Back',
  FB: 'Full Back',
  HB: 'H-Back',
  TE: 'Tight End',
  OG: 'Offensive Guard',
  OT: 'Offensive Tackle',
  C: 'Center',
  DT: 'Defensive Tackle',
  DE: 'Defensive End',
  ML: 'Middle Linebacker',
  OL: 'Outside Linebacker',
  DB: 'Cornerback',
  SS: 'Strong Safety',
  FS: 'Free Safety',
  K: 'Kicker',
  P: 'Punter',
  LS: 'Long Snapper',
};

class PostingTile extends Component {
  static propTypes = {
    item: PropTypes.shape(),
    editPosting: PropTypes.func,
    setPostingId: PropTypes.func,
    index: PropTypes.number,
  }
  static defaultProps = {
    item: {},
    attributes: {},
    editPosting: () => {},
    setPostingId: () => {},
    index: 0,
  }
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
    this.openEditPosting = this.openEditPosting.bind(this);
  }

  openEditPosting(id, index) {
    this.props.editPosting();
    this.props.setPostingId(id, index);
  }

  render() {
    const { item, index } = this.props;
    const requirements = item.get('requirements');
    return (
      <div className={styles.container}>
        <div className={styles.tile}>
          <button onClick={() => this.openEditPosting(item.get('id'), index)} className={styles.editIcon}>
            <img src="https://media.dev.myrecruitboard.com/Images/editIcon.png" alt="edit-icon" />
          </button>
          <img className={styles.colgeIcon} src="https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png" alt="college-icon" />
          <div className={styles.collegeName}>
            <span>
              {item.get('college_name')}
            </span>
            <span className={styles.lightText}>{item.get('city')}</span>
          </div>
          <div className={styles.postingTitle}>
            <span>
              {positions[item.get('posting_title')]}
            </span>
          </div>
          {/* <div className={styles.lightText}>
          Squats : {requirements.get('min_squats')},
          Gpa : {requirements.get('min_gpa')},
          T40 : {requirements.get('min_t40')}</div> */}
          <div className={styles.lightText}> Height:{requirements.get('min_height')} ,
            Weight: {requirements.get('min_weight')},
            Gpa : {requirements.get('min_gpa')}, 40-Yard Dash : {requirements.get('min_t40')}
          </div>
        </div>
      </div>
    );
  }
}

export default PostingTile;



// WEBPACK FOOTER //
// ./src/components/CoachPostings/CoachPostings.js